import {Component, Input, OnInit, ViewChild, OnChanges, ElementRef, Inject, SimpleChanges, Output,EventEmitter} from '@angular/core';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {FormControl} from '@angular/forms';
import {AuthorizationComponent} from '../../authorization/authorization.component';
import {ConfService} from '../../conf.service';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {TourStep} from 'ngx-guided-tour/lib/guided-tour.constants';
import {Orientation} from 'ngx-guided-tour';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {TestCaseData} from '../../testcase/testcase.component';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {DevexTesterDataService} from '../devex-tester-data.service';
import {map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';

class FileSnippet {
    constructor(public src: string, public file: File) {
    }
}

interface Main {
    value: string;
    viewValue: string;
}
interface Type {
    value: string;
    viewValue: string;
}

@Component({
    templateUrl: 'new-mock-response-input.html'
})
export class NewMockResponseEntryInputComponent {
    statusCode: number;
    constructor(
        public dialogRef: MatDialogRef<NewMockResponseEntryInputComponent>,
        @Inject(MAT_DIALOG_DATA) public data, public platform: LeftpanelComponent) {
        this.statusCode = this.data.statusCode;
    }

    keyPressNumbers(event) {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
            return false;
        } else {
            return true;
        }
    }

    addMockResponse() {
        if (this.statusCode > 99 && this.statusCode < 600) {
            this.dialogRef.close({statusCode: this.statusCode});
        } else {
            this.platform.openSnackBar('Please enter a valid Status Code.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }
}

interface PathParam {
    key: string;
    value: string | null;
    parameterized: boolean;
    immutable: boolean;
    field_type: string | null;
    description?: string | null;
}

@Component({
    templateUrl: 'replace-mock-data.html'
})
export class ReplaceMockDataConfirmationComponent {
    constructor(
        public dialogRef: MatDialogRef<ReplaceMockDataConfirmationComponent>,
        @Inject(MAT_DIALOG_DATA) public data, public platform: LeftpanelComponent) {
    }
}

@Component({
    selector: 'headers-cmp',
    templateUrl: './headers.component.html',
    styleUrls: ['./headers.component.css']
})

export class HeadersComponent implements OnInit, OnChanges {
    // parameterData = [];
    //  headersData = [];

    @Input() componentType = 'devex';

    fileContent: any;
    fileContentform: any;
    loading = false;
    setp = false;
    setf = false;
    seth = false;
    setu = false;
    @Input() selectedIndex: any;
    datatype = [];
    @Input() formData = [];
    fileToUpload: File = null;
    fileToUpload1: File = null;
    @Input() requestBodySelected: string;
    contentTypeExists: boolean;
    tempMethod: any;
    fileInfo: any;
    datatypes: any;
    dataTypeFilter: any;

    formDataTypes = [
        {
            displayName: 'Text',
            value: 'Text',
        },
        {
            displayName: 'File',
            value: 'File',
        }
    ];

    pathParamTypes = [
        {
            displayName: 'dynamic',
            value: true,
        },
        {
            displayName: 'static',
            value: false,
        }
    ];
    // description_flag: boolean;
    @Input() headers = ['key', 'value', 'description', 'req'];
    @Input() parametersHeaders = ['key', 'value', 'description', 'req'];

    @Input() customPathParametersHeaders = ['name', 'value', 'parameterized', 'description'];

    @Input() formDataParameters = ['key', 'type', 'value', 'description', 'req'];
    // parametersTemp = ['key', 'value'];
    requestBodyTypes = [
        {'displayName': 'None', 'value': 'none'},
        {'displayName': 'Form Data', 'value': 'form-data'},
        {'displayName': 'Form URL Encoded', 'value': 'x-www-form-urlencoded'},
        {'displayName': 'Raw', 'value': 'raw'},
        {'displayName': 'Binary / File', 'value': 'binary'}

    ];
    @Input() rawRequestBody: any;
    @Input() enableBodyParamDescription = false;
    @Input() bodyParamsDescription = [];
    //  formData = [];
    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    @ViewChild('aceEditor') aceEditorXML;
    @ViewChild('aceEditor1') aceEditorHTML;
    @ViewChild('aceEditorText') aceEditorText;
    @ViewChild('aceEditor2') aceEditorApiQl;
    @ViewChild('aceEditor3') aceEditorDataQl;
    @ViewChild(AuthorizationComponent) authModel1: AuthorizationComponent;

    options1 = new JsonEditorOptions();
    constructor(private confPost: ConfService, public platform: LeftpanelComponent, public dialog: MatDialog, private devexTesterDataService: DevexTesterDataService) {
        this.options1.mode = 'code';
        this.options1.modes = ['code', 'text', 'tree', 'view'];
        this.options1.schema = '';
        this.options1.statusBar = false;
        this.options1.onChange = () => console.log( /*this.editor.get()*/ );
    }
    @ViewChild('fileInput', {static: false})
    myFileInput: ElementRef;
    @Input() parameterData: any;
    @Input() paramModel =  {
        'key': '',
        'value': '',
        'description': '',
        'req': false
    };
    @Input() headersData: any;
    @Input() authModel: any;
    @Input() requestBody: any;
    @Input() prerequisites: any;
    @Input() description_flag: boolean;
    @Input() showPathParameters: boolean;
    @Input() pathParameter: any;
    @Input() collectInputPathParams = false;
    @Input() isCustomPath = false;
    @Input() customPathParams: PathParam[] = [];
    isNameVersionAvailableForPath = false;
    pathErrorMessage = 'Please add valid API name and version';
    customPath: string;
    @Input() localAPIByDefinition: any;
    @Input() apiURL: any;
    @Input() httpOperation: any;
    @Input() partner: any;
    @Input() account: any;
    @Input() showResponseAttributes: boolean;
    @Input() executor_name: any;
    @Input() executor_type: any;
    @Input() executor_version: any;
    @Input() executors: any;
    @Input() responseData: any;
    @Input() errorMessage: any;
    @Input() responseError: any;
    @Input() entity: any;
    @Input() selectedDatabaseType = '';
    @Input() mockResponses = [];
    @Input() responseAttributeType = true;
    @Input() rootMapping = null;
    @Output() rootMappingValueChanged = new EventEmitter<any>();
    @Input() responseType = null;
    @Output() responseTypeValueChanged = new EventEmitter<any>();
    partnerkey: any;
    account_id: any;
    apiByDefinition: any;
    editorData: any;
    filteredOptions: Observable<string[]>;
    acceptFilteredOptions: Observable<string[]>;
    contentType: string;
    set: boolean;
    mains: Main[] = [
        {value: 'Text', viewValue: 'Text'},
        {value: 'File', viewValue: 'File'}
    ];
    myControl1 = new FormControl();
    myControl = new FormControl();
    // formURLEncodedTrue:
    pushData = {
        'key': '',
        'value': '',
        'description': '',
        'req': ''
    };
    CData = {
        'key': '',
        'value': '',
        'description': '',
        'req': ''
    };
    rawTypes = [
        'JSON', 'XML', 'HTML', 'TEXT', 'APIQL', 'DATAQL'
    ];
    ctypeList = ['application/json', 'multipart/form-data', 'application/x-www-form-urlencoded', 'text/plain', 'text/HTML'];
    atypeList = ['application/json;indent=2', 'application/xml'];
    selectedRawType = 'JSON';
    types: Type[] = [
        {value: 'Accept-0', viewValue: 'Accept'},
        {value: 'AcceptCharset-1', viewValue: 'Accept-Charset'},
        {value: 'AcceptEncoding-2', viewValue: 'Accept-Encoding'},
        {value: 'AcceptLanguage-3', viewValue: 'Accept-Language'},
        {value: 'AccessControlRequestHeaders-4', viewValue: 'Access-Control-Request-Headers'},
        {value: 'AccessControlRequestMethods-5', viewValue: 'Access-Control-Request-Methods'},
        {value: 'Authorization-6', viewValue: 'Authorization'},
        {value: 'CacheControl-7', viewValue: 'Cache-Control'},
        {value: 'ContentTransferEncoding-8', viewValue: 'Content-Transfer-Encoding'},
        {value: 'Date-9', viewValue: 'Date'},
        {value: 'IfMatch-10', viewValue: 'If-Match'},
        {value: 'IfNoneMatch-11', viewValue: 'If-None-Match'},
        {value: 'IfRange-12', viewValue: 'If-Range'},
        {value: 'KeepAlive-13', viewValue: 'Keep-Alive'},
        {value: 'MaxForwards-14', viewValue: 'Max-Forwards'},
        {value: 'Pragma-15', viewValue: 'Pragma'},
        {value: 'ProxyAuthorization-16', viewValue: 'Proxy-Authorization'},
        {value: 'Range-17', viewValue: 'Range'},
        {value: 'Trailer-18', viewValue: 'Trailer'},
        {value: 'TransferEncoding-19', viewValue: 'Transfer-Encoding'},
        {value: 'Upgrade-20', viewValue: 'Upgrade'},
        {value: 'UserAgent-21', viewValue: 'User-Agent'},
        {value: 'Via-22', viewValue: 'Via'},
        {value: 'Warning-23', viewValue: 'Warning'},
        {value: 'XDoNotTrack-24', viewValue: 'X-Do-Not-Track'},
        {value: 'XApiKey-25', viewValue: 'X-Api-Key'}
    ];
    selector: any;
    selectedFormDataType = 'Text';
    formDataOptions = {
        initialFormData: new FormData(),
        showLeafArrayIndexes: true,
        includeNullValues: false,
        mapping: function(value) {
            if (typeof value === 'boolean') {
                return +value ? '1' : '0';
            }
            return value;
        }
    };

    customPathDrop(event: CdkDragDrop<Object[]>) {
        moveItemInArray(this.customPathParams, event.previousIndex, event.currentIndex);
    }

    deleteCustomPath(index) {
        this.customPathParams.splice(index, 1);
    }

    addCustomPathParam() {
        this.customPathParams.push({
            key: '',
            value: '',
            parameterized: true,
            immutable: false,
            field_type: ''
        });
    }

    emitRootMapping(value){
            this.rootMappingValueChanged.emit(value);
    }

    emitresponseTypeChange(value){
        this.responseTypeValueChanged.emit(value);
}

    pathTypedChanged(index) {
        if (!this.customPathParams[index].parameterized) {
            this.customPathParams[index]['value'] = null;
            this.customPathParams[index]['description'] = null;
        }
    }

    customPathChanged() {
        this.customPath = this.constructPath(this.customPathParams);
    }

    nameVersionUpdate() {
        this.nameVersionChangedInPath({
            name: this.executor_name,
            version: this.executor_version
        });
    }

    nameVersionChangedInPath(changes) {
        if (changes && changes.name && changes.version) {
            this.isNameVersionAvailableForPath = true;

            const nameObj = this.customPathParams.find(param => param.field_type === 'name');
            if (nameObj) {
                nameObj.key = changes.name;
            } else {
                this.customPathParams.unshift({
                    key: changes.name,
                    value: '',
                    parameterized: false,
                    immutable: true,
                    field_type: 'name'
                });
            }
            const versionObj = this.customPathParams.find(param => param.field_type === 'version');
            if (versionObj) {
                versionObj.key = changes.version;
            } else {
                this.customPathParams.unshift({
                    key: changes.version,
                    value: '',
                    parameterized: false,
                    immutable: true,
                    field_type: 'version'
                });
            }

        } else {
            this.isNameVersionAvailableForPath = false;
            this.pathErrorMessage = 'Please add valid API name and version';
        }
        this.customPathChanged();
    }

    constructPath(pathParams: PathParam[]) {
        let path = '';
        for (const param of pathParams) {
            if (!param.parameterized) {
                path += `/${param.key}`;
            } else if (param.parameterized) {
                path += `/{${param.key}}`;
            }
        }
        return path;
    }

    getCustomPathAsParams() {
        const params = [];
        this.customPathParams.forEach(value => {
            if (value.parameterized) {
                params.push({
                    key: value.key,
                    value: value.value,
                    description: value.description,
                    annotation: 'PathVariable'
                });
            }
        });
        return params;
    }

    getCustomPathVariables() {
        return this.customPathParams;
    }
    isBodyParamDescriptionEnabled() {
        return this.enableBodyParamDescription;
    }
    getBodyParamDescription() {
        return this.bodyParamsDescription;
    }

    isCustomPathValid() {
        return new Promise((resolve, reject) => {
            if (this.isCustomPath) {
                let nameCount = 0;
                let versionCount = 0;
                for (const field of this.customPathParams) {
                    if (!field.key) {
                        reject('Custom Path value cannot be empty');
                    }
                    if (field.field_type === 'name') {
                        nameCount++;
                    }
                    if (field.field_type === 'version') {
                        versionCount++;
                    }
                }
                if (nameCount !== 1 || versionCount !== 1) {
                    reject('Custom Path must contain API name and version');
                }
                resolve(true);
            } else {
                resolve(true);
            }
        });
    }

    checkContentType() {
            for (const header of this.headersData) {
                if (header && header['key'] === 'Content-Type') {
                    switch (header['value']) {
                        case 'multipart/form-data':
                            this.requestBodySelected = 'form-data';
                            this.contentTypeExists = true;
                            if (typeof this.requestBody !== undefined && this.requestBody !== null) {
                                if (Object.keys(this.requestBody).length !== 0) {
                                    this.formData = this.requestBody.value;
                                }
                            }
                            break;
                        case 'application/x-www-form-urlencoded':
                            this.requestBodySelected = 'x-www-form-urlencoded';
                            this.contentTypeExists = true;
                            if (typeof this.requestBody !== undefined && this.requestBody !== null) {
                                if (Object.keys(this.requestBody).length !== 0) {
                                    this.formData = this.requestBody.value;
                                }
                            }
                            break;
                        case 'application/json':
                            this.requestBodySelected = 'raw';
                            this.contentTypeExists = true;
                            if (this.typeOf(this.requestBody) === 'array' && this.requestBody[0] !== null) {
                                this.rawRequestBody = this.requestBody[0].value;
                            } else if (this.requestBody === undefined || this.requestBody === null) {
                                this.requestBody = {};
                                // this.rawRequestBody = this.requestBody.value;
                            } else {
                                this.rawRequestBody = this.requestBody.value;
                            }
                            break;
                        case 'text/plain':
                            this.requestBodySelected = 'raw';
                            this.contentTypeExists = true;
                            this.selectedRawType = 'TEXT';
                            if (this.typeOf(this.requestBody) === 'array' && this.requestBody[0] !== null) {
                                this.rawRequestBody = this.requestBody[0].value;
                            } else if (this.requestBody === undefined || this.requestBody === null) {
                                this.requestBody = {};
                                // this.rawRequestBody = this.requestBody.value;
                            } else {
                                this.rawRequestBody = this.requestBody.value;
                            }
                            break;
                    }
                }
            }
        if (this.contentTypeExists && this.contentTypeExists !== true) {
            if (this.componentType !== 'apiql' && this.componentType !== 'dataql') {
                this.requestBodySelected = 'none';
            }
        }
    }
    typeOf(object) {
        const stringConstructor = 'test'.constructor;
        const arrayConstructor = [].constructor;
        const objectConstructor = ({}).constructor;

        if (object === null) {
            return 'null';
        }
        if (object === undefined) {
            return 'undefined';
        }
        if (object.constructor === stringConstructor) {
            return 'String';
        }
        if (object.constructor === arrayConstructor) {
            return 'array';
        }
        if (object.constructor === objectConstructor) {
            return 'object';
        }
        {
            return 'don\'t know';
        }
    }
    async ngOnChanges(changes: SimpleChanges) {
        let isToBeUpdated = false;
        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                switch (propName) {
                    case 'executor_name':
                        this.nameVersionUpdate();
                        break;
                    case 'executor_version':
                        this.nameVersionUpdate();
                        break;
                    default:
                        isToBeUpdated = true;
                        break;
                }
            }
        }
        if (isToBeUpdated) {
            this.mockResponses = this.mockResponses ? this.mockResponses : [];
            if (changes['httpOperation']) {
                this.setDevexRequestBody();
            }
            // this.setDevexRequestBody();
            if ((this.tempMethod !== this.httpOperation) || this.headersData) {
                this.tempMethod = this.httpOperation;

                this.setParamsConditions();
                if (this.httpOperation === 'GET') {
                    // this.headersData = [];
                    if (this.parameterData === null || this.parameterData === undefined) {
                        this.parameterData = [];
                    }
                    if (this.parameterData && this.parameterData !== null && this.parameterData !== undefined && this.parameterData.length === 0) {
                        this.setp = true;
                        this.addParameter();
                    }
                    // this.selectedIndex = 2;
                    // for (const i in this.headersData) {
                    //     if (this.headersData[i]['key'] === 'Content-Type') {
                    //         this.headersData.splice(i, 1);
                    //         // delete this.headersData[i];
                    //     }
                    // }
                    // this.requestBodySelected = 'none';
                } else if (this.componentType === 'apiql' || this.componentType === 'dataql') {
                    this.selectedIndex = 3;
                    this.requestBodySelected = 'raw';
                    this.attachContentType('text/plain');
                    this.selectedRawType = this.componentType === 'apiql' ? 'APIQL' : 'DATAQL';

                    this.rawTypes = this.componentType === 'apiql' ? [
                        'JSON', 'APIQL'
                    ] : [
                        'JSON', 'DATAQL'
                    ];

                    if (this.parameterData && this.parameterData !== null && this.parameterData !== undefined && this.parameterData.length > 0 && this.parameterData[this.parameterData.length - 1]['key'] === '') {
                        this.parameterData.splice(this.parameterData.length - 1, 1);
                    }
                } else if (this.seth) {

                } else if (this.httpOperation === 'PUT' || this.httpOperation === 'POST' || this.httpOperation === 'PATCH') {
                    // this.selectedIndex = 3;
                    // this.requestBodySelected = 'raw';
                    this.attachContentType('application/json');
                    if (this.parameterData && this.parameterData !== null && this.parameterData !== undefined && this.parameterData.length > 0 && this.parameterData[this.parameterData.length - 1]['key'] === '') {
                        this.parameterData.splice(this.parameterData.length - 1, 1);
                    }
                }

                await this.checkContentType();
            }
            if (this.partner !== undefined) {
                this.partnerkey = this.partner;
            } else {
                this.partnerkey = localStorage.getItem('partner');
            }
            if (this.account !== undefined) {
                this.account_id = this.account;
            } else {
                this.account_id = localStorage.getItem('account');
            }
            if (this.parameterData && this.parameterData !== null && this.parameterData !== undefined && this.parameterData.length > 0) {
                this.setp = true;
            }
            if (this.headersData && this.headersData !== null && this.headersData !== undefined && this.headersData.length > 0) {
                this.seth = true;
            }
            if (this.formData && this.formData !== null && this.formData !== undefined && this.formData.length > 0) {
                this.setf = true;
            }
            if (this.formData && this.formData !== null && this.formData !== undefined && this.formData.length > 0) {
                this.setu = true;
            }
            // await this.checkContentType();
            // this.formData = this.requestBody.value;
            this.apiByDefinition = this.localAPIByDefinition;
            this.loading = true;
            this.filterDataTypes();
        }
    }
    onFileSelect(input: HTMLInputElement): void {
        function formatBytes(bytes: number): string {
            const UNITS = ['Bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            const factor = 1024;
            let index = 0;

            while (bytes >= factor) {
                bytes /= factor;
                index++;
            }

            return `${parseFloat(bytes.toFixed(2))} ${UNITS[index]}`;
        }

        const file = input.files[0];
        this.fileInfo = `${file.name} (${formatBytes(file.size)})`;
    }

    setIsFile(param) {
        param['isFile'] = param.type === 'File';
    }

    onFormDataFileChange(fileParam, data) {
        // const file = fileList[0];
        const file: File = fileParam.files[0];
        const fileReader: FileReader = new FileReader();
        const fileByteArray = [];
        // fileReader.readAsArrayBuffer(file);
        fileReader.readAsDataURL(file);
        fileReader.onloadend = function (evt: any) {
            if (evt.target.readyState === FileReader.DONE) {
                // array buffer
                // const arrayBuffer = evt.target.result,
                //     array = new Uint8Array(arrayBuffer);
                // for (let i = 0; i < array.length; i++) {
                //     fileByteArray.push(array[i]);
                // }
                // data.value = fileByteArray;

                const base64String = evt.target.result;
                const mimeType = file.type;
                const fileName = file.name;
                const base64StringWithFileName = `data:${mimeType};name=${fileName};base64,${base64String.split(',')[1]}`;
                data.value = base64StringWithFileName;
            }
        };
        // fileReader.addEventListener('load', (event: any) => {
        //     const selectedFile = new FileSnippet(event.target.result, file);
        //     // data.value = {file: selectedFile.file, fileName: selectedFile.file.name}
        //     data.value = selectedFile.file;
        // });
        data['fileName'] = file.name;
    }

     public onChange(fileList: FileList): void {
        this.rawRequestBody = '';
        const file = fileList[0];
        const fileReader: FileReader = new FileReader();
        const self = this;
        fileReader.onloadend = function(x) {
            self.rawRequestBody = fileReader.result;
        };
        fileReader.readAsText(file);
    }
    deselectFile() {

        if (confirm('Are you sure you want to remove this file?')) {
            this.myFileInput.nativeElement.value = '';
            this.rawRequestBody = '';
        }
    }

    getHeaderCmpSteps(): Array<TourStep> {

        let steps: TourStep[] = [];

        steps.push({
            title: this.platform.getProperty('GT_HEADERS_CMP_HEADER_TAB_TITLE'),
            selector: '.tour-headers-cmp-root-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(1) > div',
            content: this.platform.getProperty('GT_HEADERS_CMP_HEADER_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {this.selectedIndex = 0; })
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_ADD_HEADER_TITLE'),
            selector: '.tour-headers-cmp-add-header',
            content: this.platform.getProperty('GT_HEADERS_CMP_ADD_HEADER_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_HEADER_KEY_TITLE'),
            selector: '.tour-headers-cmp-header-key',
            content: this.platform.getProperty('GT_HEADERS_CMP_HEADER_KEY_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_HEADER_VALUE_TITLE'),
            selector: '.tour-headers-cmp-header-value',
            content: this.platform.getProperty('GT_HEADERS_CMP_HEADER_VALUE_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_HEADER_DESCRIPTION_TITLE'),
            selector: '.tour-headers-cmp-header-description',
            content: this.platform.getProperty('GT_HEADERS_CMP_HEADER_DESCRIPTION_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_HEADER_REQUIRED_TITLE'),
            selector: '.tour-headers-cmp-header-mention',
            content: this.platform.getProperty('HEADERS_CMP_HEADER_REQUIRED_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_REMOVE_HEADER_TITLE'),
            selector: '.tour-headers-cmp-remove-header',
            content: this.platform.getProperty('GT_HEADERS_CMP_REMOVE_HEADER_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_AUTHORIZATION_TAB_TITLE'),
            selector: '.tour-headers-cmp-root-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(2) > div',
            content: this.platform.getProperty('GT_HEADERS_CMP_AUTHORIZATION_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {this.selectedIndex = 1; })
        }, {
            title: this.platform.getProperty('GT_AUTHORIZATION_TITLE'),
            selector: '.tour-authorization',
            content: this.platform.getProperty('GT_AUTHORIZATION_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_PARAMETERS_TAB_TITLE'),
            selector: '.tour-headers-cmp-root-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(3) > div',
            content: this.platform.getProperty('GT_HEADERS_CMP_PARAMETERS_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {this.selectedIndex = 2; })
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_ADD_PARAMETER_TITLE'),
            selector: '.tour-headers-cmp-add-parameter',
            content: this.platform.getProperty('GT_HEADERS_CMP_ADD_PARAMETER_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_PARAMETER_KEY_TITLE'),
            selector: '.tour-headers-cmp-parameter-key',
            content: this.platform.getProperty('GT_HEADERS_CMP_PARAMETER_KEY_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_PARAMETER_VALUE_TITLE'),
            selector: '.tour-headers-cmp-parameter-value',
            content: this.platform.getProperty('GT_HEADERS_CMP_PARAMETER_VALUE_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_PARAMETER_DESCRIPTION_TITLE'),
            selector: '.tour-headers-cmp-parameter-description',
            content: this.platform.getProperty('GT_HEADERS_CMP_PARAMETER_DESCRIPTION_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_PARAMETER_REQUIRED_TITLE'),
            selector: '.tour-headers-cmp-parameter-mention',
            content: this.platform.getProperty('HEADERS_CMP_PARAMETER_REQUIRED_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_REMOVE_PARAMETER_TITLE'),
            selector: '.tour-headers-cmp-remove-parameter',
            content: this.platform.getProperty('GT_HEADERS_CMP_REMOVE_PARAMETER_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_REQUEST_BODY_TAB_TITLE'),
            selector: '.tour-headers-cmp-root-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(4) > div',
            content: this.platform.getProperty('GT_HEADERS_CMP_REQUEST_BODY_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {this.selectedIndex = 3; })
        }, {
            title: this.platform.getProperty('GT_HEADERS_CMP_REQUEST_BODY_TITLE'),
            selector: '.tour-headers-cmp-request-body',
            content: this.platform.getProperty('GT_HEADERS_CMP_REQUEST_BODY_CONTENT'),
            orientation: Orientation.Bottom
        });
        if (this.requestBodySelected === 'raw') {
            steps.push({
                title: this.platform.getProperty('GT_HEADERSCMP_EDITOR_TITLE'),
                selector: '.tour-headers-cmp-request-body-editor',
                content: this.platform.getProperty('GT_HEADERSCMP_EDITOR_CONTENT'),
                orientation: Orientation.Bottom});
        }
        steps.push({
            title: this.platform.getProperty('GT_HEADERS_CMP_RESPONSE_ATTRIBUTES_TAB_TITLE'),
            selector: '.tour-headers-cmp-root-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(5) > div',
            content: this.platform.getProperty('GT_HEADERS_CMP_RESPONSE_ATTRIBUTES_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {this.selectedIndex = 4; })
        });

        steps = steps.concat(this.platform.getSchemaDefinitionTourSteps(false));

        return steps;

    }

    _filter(value: string): string[] {
        const filterValue = value.toLowerCase();

        return this.ctypeList.filter(option => option.toLowerCase().includes(filterValue));
    }

    _aFilter(value: string): string[] {
        const filterValue = value.toLowerCase();

        return this.atypeList.filter(option => option.toLowerCase().includes(filterValue));
    }

    async ngOnInit() {
        this.mockResponses = this.mockResponses ? this.mockResponses : [];

        Promise.resolve(this.devexTesterDataService.setRawDataKeyTypes()).then((resp) => {}, error => {});

        this.tempMethod = this.httpOperation;
        // if (this.httpOperation === 'GET') {
        //     this.setp = true;
        //     this.addParameter();
        // }

        if (this.parameterData && this.parameterData !== null && this.parameterData !== undefined && this.parameterData.length > 0) {
            this.setp = true;
        }
        if (this.headersData && this.headersData !== null && this.headersData !== undefined && this.headersData.length > 0) { 
            this.seth = true;
        }
        if (this.formData && this.formData !== null && this.formData !== undefined && this.formData.length > 0) {
            this.setf = true;
        }
        if (this.formData && this.formData !== null && this.formData !== undefined && this.formData.length > 0) {
            this.setu = true;
        }

        this.setRequestBodyParameters();
        this.setDevexRequestBody();

        this.apiByDefinition = this.localAPIByDefinition;
        // await this.checkContentType();
        // this.description_flag;
        // this.addParameter();
        // this.addHeader();
        // this.addFormData();
        this.selector = 'Text';

        if (this.platform.datatypes !== null && this.platform.datatypes !== undefined) {
            this.datatypes = this.platform.datatypes;
            this.filterDataTypes();
        } else {
            await this.confPost.getDataTypes().toPromise().then(data => {
                this.datatypes = data;
                this.platform.datatypes = data;
                this.filterDataTypes();
            },
            error => {
                this.platform.handleErrorGracefully(error, 'Error while getting list of data types. Please try again after sometime.');
            });
        }

        this.platform.setheaderCmpTourSteps(this.getHeaderCmpSteps());

        this.filteredOptions = this.myControl.valueChanges
                    .pipe(
                        startWith(''),
                        map(value => this._filter(value))
                    );
        this.acceptFilteredOptions = this.myControl.valueChanges
        .pipe(
            startWith(''),
            map(value => this._aFilter(value))
        );
    }


    setParamsConditions() {
        if (this.parameterData && this.parameterData !== null && this.parameterData !== undefined && this.parameterData.length > 0) {
            this.setp = true;
        }
        if (this.headersData && this.headersData !== null && this.headersData !== undefined && this.headersData.length > 0) {
            this.seth = true;
        }
        if (this.formData && this.formData !== null && this.formData !== undefined && this.formData.length > 0) {
            this.setf = true;
        }
        if (this.formData && this.formData !== null && this.formData !== undefined && this.formData.length > 0) {
            this.setu = true;
        }
    }

    setRequestBodyParameters() {
        if (this.componentType === 'apiql') {
            this.requestBodySelected = 'raw';
            this.selectedRawType = 'APIQL';
            this.selectedIndex = 3;
        } else if (this.componentType === 'dataql') {
            this.selectedIndex = 3;
            this.requestBodySelected = 'raw';
            this.selectedRawType = 'DATAQL';
        } else if (this.componentType === 'tester' && (this.httpOperation === 'PUT' ||
            this.httpOperation === 'POST' || this.httpOperation === 'PATCH')) {
            this.requestBodySelected = 'raw';
            this.selectedRawType = 'JSON';
        } else if (this.seth) {
            this.selectedIndex = 3;
            this.checkContentType();
        }
    }


    setDevexRequestBody() {
        if (this.componentType === 'devex' && (this.httpOperation === 'GET' ||
            this.httpOperation === 'DELETE')) {
            this.selectedIndex = 2;
        } else if (this.componentType === 'devex' && (this.httpOperation === 'PUT' ||
            this.httpOperation === 'POST')) {
            this.selectedIndex = 3;
            this.checkContentType();
        } else if (this.componentType === 'devex' && (this.httpOperation === 'PATCH')) {
            this.selectedIndex = 3;
            this.requestBodySelected = 'raw';
            this.selectedRawType = 'JSON';
            // this.attachContentType('application/json');
        }
    }

    addParameter() {
        // const pushData = {
        //     'key': '',
        //     'value': '',
        //     'description': '',
        //     'req': false
        // };
        this.parameterData.push(JSON.parse(JSON.stringify(this.paramModel)));
        this.setp = true;
    }
    changeData(value) {
        if (value['authType'] === 'api_key') {
            if (value['authAttributes']['key'] !== null && value['authAttributes']['value'] !== null && value['authAttributes']['add_to'] === 'header') {
                for (let i = 0 ; i < this.parameterData.length ; i++ ) {
                    if (this.parameterData[i]['key'] === value['authAttributes']['key'] || this.parameterData[i]['value'] === value['authAttributes']['value']) {
                        this.parameterData.splice(i, 1);
                        break;
                    }
                }
                let flag = false;
                for (let j = 0 ; j < this.headersData.length; j++) {
                    if (this.headersData[j]['key'] === value['authAttributes']['key'] && (this.headersData[j]['value'].includes(value['authAttributes']['value']) || value['authAttributes']['value'].includes(this.headersData[j]['value']))) {
                        flag = true;
                        this.headersData[j]['value'] = value['authAttributes']['value'];
                    } else if (this.headersData[j]['value'] === value['authAttributes']['value'] && (this.headersData[j]['key'].includes(value['authAttributes']['key']) || value['authAttributes']['key'].includes(this.headersData[j]['key']))) {
                        flag = true;
                        this.headersData[j]['key'] = value['authAttributes']['key'];
                    }
                }
                if (flag === false) {
                    this.headersData.push({key: value['authAttributes']['key'], value: value['authAttributes']['value'], description: ''});
                }
            } else if (value['authAttributes']['key'] !== null && value['authAttributes']['value'] !== null && value['authAttributes']['add_to'] === 'query_param') {
                for (let i = 0; i < this.headersData.length; i++) {
                    if (this.headersData[i]['key'] === value['authAttributes']['key'] || this.headersData[i]['value'] === value['authAttributes']['value']) {
                        this.headersData.splice(i, 1);
                        break;
                    }
                }
                    let flag = false;
                    for (let j = 0 ; j < this.parameterData.length; j++) {
                        if (this.parameterData[j]['key'] === value['authAttributes']['key'] && (this.parameterData[j]['value'].includes(value['authAttributes']['value']) || value['authAttributes']['value'].includes(this.parameterData[j]['value']))) {
                            flag = true;
                            this.parameterData[j]['value'] = value['authAttributes']['value'];
                        } else if (this.parameterData[j]['value'] === value['authAttributes']['value'] && (this.parameterData[j]['key'].includes(value['authAttributes']['key']) || value['authAttributes']['key'].includes(this.parameterData[j]['key']))) {
                            flag = true;
                            this.parameterData[j]['key'] = value['authAttributes']['key'];
                        }
                    }
                    if (flag === false) {
                        if (this.parameterData && this.parameterData.length > 0 && this.parameterData[this.parameterData.length - 1]['key'] === '' && this.parameterData[this.parameterData.length - 1]['value'] === '') {
                            this.parameterData[this.parameterData.length - 1]['key'] = value['authAttributes']['key'];
                            this.parameterData[this.parameterData.length - 1]['value'] = value['authAttributes']['value'];
                        } else {
                            this.parameterData.push({
                                key: value['authAttributes']['key'],
                                value: value['authAttributes']['value'],
                                description: ''
                            });
                        }
                    }
            }
        } else {
            if (value['authAttributes']['key'] && value['authAttributes']['value']) {
                for (let i = 0 ; i < this.parameterData.length ; i++ ) {
                    if (this.parameterData[i]['key'] === value['authAttributes']['key'] && this.parameterData[i]['value'] === value['authAttributes']['value']) {
                        this.parameterData.splice(i, 1);
                        break;
                    }
                }
                for (let i = 0 ; i < this.headersData.length ; i++ ) {
                    if (this.headersData[i]['key'] === value['authAttributes']['key'] && this.headersData[i]['value'] === value['authAttributes']['value']) {
                        this.headersData.splice(i, 1);
                        break;
                    }
                }
            }
        }
    }
    removeParameter(index) {
        // delete this.parameterData[index];
        this.parameterData.splice(index, 1);
        
    }
    addNewHeader(val) {
        if (val === this.headersData.length - 1) {
            this.addHeader();
        }
    }
    addNewParameter(val) {
        if (val === this.parameterData.length - 1) {
            this.addParameter();
        }
    }
    addNewForm(val) {
        if (val === this.formData.length - 1) {
            this.addFormData();
        }
    }
    executeApiAndLoadResponse() {
        this.responseData = '';
        this.errorMessage = '';
        this.responseError = '';
        // if (this.authModel.hasOwnProperty('authType') && this.authModel.authType === 'no_auth'){
        //
        //     this.authModel = null;
        // }

        const payload = {
            'executor_name': this.executor_name,
            'executor_type': this.executor_type !== null ? this.executor_type : 'API',
            'executor_version': this.executor_version,
            'executor_method_type': this.httpOperation,
            'apiUrl': this.apiURL,
            'queryParams': this.parameterData,
            'pathParams': this.pathParameter,
            'headers': this.headersData,
            'authModel': this.authModel1.authModel,
            'requestBody': this.getRequestBody(),
            'executors': this.executors,
        };
        if (!(payload.authModel.hasOwnProperty('authType') && payload.authModel['authType'] !== 'no_auth')) {
            payload.authModel = null;
        }
        this.confPost.getResponseAttribute(this.partnerkey, this.account_id, payload).subscribe(response => {
            this.apiByDefinition = response;
        });
        // this._service.(payload).subscribe(response => {
        //         this.responses = response;
        //         this.responseItems = this.responses.body;
        //         let returnObject = JSON.parse(this.responseItems.body);
        //     },
        //     error => {
        //         if (error.error.message) {
        //             // Need to revisit this part later
        //             if (error.error.message.substring(error.error.message.lastIndexOf('{'), error.error.message.indexOf('}') + 1)) {
        //                 this.responseObject = JSON.parse(error.error.message.substring(error.error.message.lastIndexOf('{'), error.error.message.indexOf('}') + 1));
        //                 this.responseCode = this.responseObject.status;
        //                 this.errorMessage = this.responseObject.message;
        //                 this.responseError = this.responseObject.error;
        //                 this.responseTimestamp = this.responseObject.timestamp;
        //             } else {
        //                 this.responseCode = error.error.status;
        //                 this.errorMessage = error.error.message;
        //                 this.responseError = 'Internal Server Error';
        //             }
        //         } else {
        //             this.responseCode = 500;
        //             this.errorMessage = 'Error while processing your request. Please check the headers and query parameters that may be missing in your request.';
        //             this.responseError = 'Internal Server Error';
        //         }
        //         this.error = true;
        //     }
        // );
    }

    addHeader() {
        this.seth = true;
        const pushData = {
            'key': '',
            'value': '',
            'description': '',
            'req': false
        };
        this.headersData.push(pushData);
        // if (pushData && this.headersData) {
        //     this.headersData.push(pushData);
        // }
    }

    attachContentType(type) {
        let contentTypeExists: boolean;
        for (const header of this.headersData) {
            if (header) {
                if (header['key'] === 'Content-Type') {
                    header['value'] = type;
                    header['req'] = false;
                    contentTypeExists = true;
                }
            }
        }
        if (contentTypeExists !== true) {
            this.headersData.push({'key': 'Content-Type', 'value': type, 'description': '', 'req': false});
        }
    }

    removeHeader(index) {
        // delete this.headersData[index];
        this.headersData.splice(index, 1);
    }

    detectFormDataType(data) {
        if (data['isFile'] === true) {
            data['isFile'] = false;
            data['type'] = 'Text';
        } else if (data['isFile'] === false) {
            data['isFile'] = true;
            data['type'] = 'File';
        }
    }

    addFormData() {
        this.setf = true;
        const pushData = {
            'key': '',
            'value': '',
            'description': '',
            'req': false,
            'isFile': false,
            'type': 'Text'
        };
        this.selectedFormDataType = 'Text';
        this.formData.push(pushData);
    }
    removeFormData(index) {
        // delete this.formData[index];

        if (confirm('Are you sure you want to remove this data?')) {
            this.formData.splice(index, 1);
        }
    }

    getEditorData() {
        return new Promise((resolve, reject) => {
            try {
                this.editorData = this.editor.get();
                resolve(this.editorData);
            } catch (e) {
                reject(e);
            }
        });
    }

    getAceEditorData() {
        return new Promise((resolve, reject) => {
            try {
                this.editorData = this.aceEditorXML.getValue();
                resolve(this.editorData);
            } catch (e) {
                reject(e);
            }
        });
    }

    async getRequestBodyValue(val) {
        switch (val) {
            case 'raw':
                // return JSON.stringify(this.editor.get());
                // return this.rawRequestBody;
                if (this.selectedRawType === 'JSON') {
                    await this.getEditorData().then(resp => {
                        return resp;
                    }, error => {
                        this.platform.openSnackBar(error, 'Error', {
                            duration: 60000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    });
                } else if (this.selectedRawType === 'XML') {
                    await this.getAceEditorData().then(resp => {
                        return resp;
                    }, error => {
                        this.platform.openSnackBar(error, 'Error', {
                            duration: 60000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    });
                }
            case 'binary':
            case 'none':
            default:
        }
    }
    stringifyjson(val) {
        return JSON.stringify(val);
    }

    rawTypeChange() {
        if (this.selectedRawType === 'JSON') {
            this.attachContentType('application/json');
        } else if (this.selectedRawType === 'XML') {
            this.attachContentType('application/xml');
        } else if (this.selectedRawType === 'HTML') {
            this.attachContentType('text/html');
        } else if (this.selectedRawType === 'TEXT') {
            this.attachContentType('text/plain');
        } else if (this.selectedRawType === 'APIQL') {
            this.attachContentType('text/plain');
        } else if (this.selectedRawType === 'DATAQL') {
            this.attachContentType('text/plain');
        }
    }

    refreshRequestBody() {
        this.requestBody = {};
        this.formData = [];
        this.rawRequestBody = {};
        switch (this.requestBodySelected) {
            case 'none':
                for (const i in this.headersData) {
                    if (this.headersData[i]['key'] === 'Content-Type') {
                        this.headersData.splice(i, 1);
                        // delete this.headersData[i];
                    }
                }
                break;
            case 'form-data':
                this.seth = true;
                this.attachContentType('multipart/form-data');
                break;
            case 'x-www-form-urlencoded':
                this.seth = true;
                this.attachContentType('application/x-www-form-urlencoded');
                break;
            case 'raw':
                this.seth = true;
                if (this.selectedRawType === 'JSON') {
                    this.attachContentType('application/json');
                } else if (this.selectedRawType === 'XML') {
                    this.attachContentType('application/xml');
                } else if (this.selectedRawType === 'HTML') {
                    this.attachContentType('text/html');
                } else if (this.selectedRawType === 'APIQL') {
                    this.attachContentType('text/plain');
                } else if (this.selectedRawType === 'DATAQL') {
                    this.attachContentType('text/plain');
                }
                break;
        }
    }

    isValidEditorContent() {
        return new Promise((resolve, reject) => {
            let isValidContent = true;
            const annotations = this.aceEditorXML.getEditor().getSession().getAnnotations();
            annotations.forEach((annotation) => {
                if (annotation && annotation !== null && annotation !== undefined) {
                    if (annotation.type === 'error') {
                        isValidContent = false;
                    }
                }
            });
            if (isValidContent) {
                resolve('success');
            } else {
                reject('Please check the request body syntax.');
            }
        });
    }

    get rawRequestBodyValue() {
        if (this.editor && this.editor.isValidJson()) {
            return  this.editor.get();
        }
        return null;
    }

    validateAndGetData() {
        if (this.selectedRawType === 'JSON') {
            if (this.editor.isValidJson()) {
                this.editorData = this.editor.get();
                const requestbody = {
                    // 'value': this.getRequestBodyValue(this.requestBodySelected),
                    'value': this.editorData,
                    'key' : 'payload',
                    'description' : 'Document in JSON format',
                    'annotation' : 'RequestBody'
                };
                return requestbody;
            } else {
                this.platform.handleErrorGracefully(null, 'Error while getting value from JSON editor.');
            }
        } else if (this.selectedRawType === 'XML') {
            let isValidContent = true;
            const annotations = this.aceEditorXML.getEditor().getSession().getAnnotations();
                annotations.forEach((annotation) => {
                    if (annotation && annotation !== null && annotation !== undefined) {
                        if (annotation.type === 'error') {
                            isValidContent = false;
                        }
                    }
                });
                if (isValidContent) {
                    this.editorData = this.aceEditorXML.getEditor().getSession().getValue();
                    this.editorData = this.editorData.replace(/\n/g, '');
                    const requestbody = {
                        // 'value': this.getRequestBodyValue(this.requestBodySelected),
                        'value': this.editorData,
                        'key' : 'payload',
                        'description' : 'Document in XML format',
                        'annotation' : 'RequestBody'
                    };
                    return requestbody;
                } else {
                    this.platform.handleErrorGracefully(null, 'Please check the request body syntax.');
                }
        } else if (this.selectedRawType === 'HTML') {
            let isValidContent = true;
            const annotations = this.aceEditorHTML.getEditor().getSession().getAnnotations();
            annotations.forEach((annotation) => {
                if (annotation && annotation !== null && annotation !== undefined) {
                    if (annotation.type === 'error') {
                        isValidContent = false;
                    }
                }
            });
            if (isValidContent) {
                this.editorData = this.aceEditorHTML.getEditor().getSession().getValue();
                this.editorData = this.editorData.replace(/\n/g, '');
                const requestbody = {
                    // 'value': this.getRequestBodyValue(this.requestBodySelected),
                    'value': this.editorData,
                    'key' : 'payload',
                    'description' : 'Document in HTML format',
                    'annotation' : 'RequestBody'
                };
                return requestbody;
            } else {
                this.platform.handleErrorGracefully(null, 'Please check the request body syntax.');
            }
        } else if (this.selectedRawType === 'TEXT') {
            let isValidContent = true;
            const annotations = this.aceEditorText.getEditor().getSession().getAnnotations();
            annotations.forEach((annotation) => {
                if (annotation && annotation !== null && annotation !== undefined) {
                    if (annotation.type === 'error') {
                        isValidContent = false;
                    }
                }
            });
            if (isValidContent) {
                this.editorData = this.aceEditorText.getEditor().getSession().getValue();
                this.editorData = this.editorData.replace(/\n/g, '');
                const requestbody = {
                    // 'value': this.getRequestBodyValue(this.requestBodySelected),
                    'value': this.editorData,
                    'key' : 'payload',
                    'description' : 'Document in Text format',
                    'annotation' : 'RequestBody'
                };
                return requestbody;
            } else {
                this.platform.handleErrorGracefully(null, 'Please check the request body syntax.');
            }
        } else if (this.selectedRawType === 'APIQL') {
            let isValidContent = true;
            const annotations = this.aceEditorApiQl.getEditor().getSession().getAnnotations();
            annotations.forEach((annotation) => {
                if (annotation && annotation !== null && annotation !== undefined) {
                    if (annotation.type === 'error') {
                        isValidContent = false;
                    }
                }
            });
            if (isValidContent) {
                this.editorData = this.aceEditorApiQl.getEditor().getSession().getValue();
                this.editorData = this.editorData.replace(/\n/g, ' ');
                const requestbody = {
                    // 'value': this.getRequestBodyValue(this.requestBodySelected),
                    'value': this.editorData,
                    'key' : 'payload',
                    'description' : 'Document in APIQL format',
                    'annotation' : 'RequestBody'
                };
                return requestbody;
            } else {
                this.platform.handleErrorGracefully(null, 'Please check the request body syntax.');
            }
        } else if (this.selectedRawType === 'DATAQL') {
            let isValidContent = true;
            const annotations = this.aceEditorDataQl.getEditor().getSession().getAnnotations();
            annotations.forEach((annotation) => {
                if (annotation && annotation !== null && annotation !== undefined) {
                    if (annotation.type === 'error') {
                        isValidContent = false;
                    }
                }
            });
            if (isValidContent) {
                this.editorData = this.aceEditorDataQl.getEditor().getSession().getValue();
                this.editorData = this.editorData.replace(/\n/g, ' ');
                const requestbody = {
                    // 'value': this.getRequestBodyValue(this.requestBodySelected),
                    'value': this.editorData,
                    'key' : 'payload',
                    'description' : 'Document in DATAQL format',
                    'annotation' : 'RequestBody'
                };
                return requestbody;
            } else {
                this.platform.handleErrorGracefully(null, 'Please check the request body syntax.');
            }
        }
    }
    getRequestBodySelected() {
        return this.requestBodySelected;
    }
    async getRequestBody() {
        if (this.requestBodySelected === 'raw') {
                return this.validateAndGetData();
        } else if (this.requestBodySelected === 'form-data') {
            const formData = new FormData();
            this.formData.forEach(data => {
                if (data && data !== null && data !== undefined) {
                    formData.append(data['key'], data['value']);
                    // if (data['isFile'] === true) {
                    //     formData.append(data['key'], data['value']['file']);
                    // } else {
                    //     formData.append(data['key'], data['value']);
                    // }
                }
            });
            const requestbody = {
                'value': this.formData,
                // 'value': formData,
                'key' : 'payload',
                'description' : 'Document in JSON format',
                'annotation' : 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'x-www-form-urlencoded') {
            const requestbody = {
                'value': this.formData,
                'key' : 'payload',
                'description' : 'Document in JSON format',
                'annotation' : 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'none') {
            const requestbody = {
                'value': '',
                'key' : 'payload',
                'description' : 'Document in JSON format',
                'annotation' : 'RequestBody'
            };
            return requestbody;
        }
    }

    getParamWidth(val) {
        return Math.floor(100 / (val.length - 1)).toString() + '%';
    }

    filterDataTypes() {
        // this.selectedDatabaseType = 'mysql';
        this.dataTypeFilter = [];
        if (this.datatypes) {
            this.datatypes.filter(items => {
                if (items.database_type === this.selectedDatabaseType) {
                    this.dataTypeFilter.push(items);
                }
            });
        }
    }

    addMockResponse() {

        const dialogRef = this.dialog.open(NewMockResponseEntryInputComponent, {
            width: '30%',
            data: {statusCode: null}
        });

        dialogRef.afterClosed().subscribe(async result => {
            if (result) {
                this.addOrUpdateMockResponse({
                    statusCode: parseInt(result.statusCode),
                    methodType: this.httpOperation,
                    headers: [],
                    message: null,
                    description: null,
                    sampleData: null,
                    responseAttributes: [],
                }, true);
            }
        });
    }

     removeMockResponse(index) {
        this.mockResponses.splice(index, 1);
    }

    async addOrUpdateMockResponse(data, confirmationReq) {
        const index = this.mockResponses.findIndex(value => value['statusCode'] === data['statusCode']);

        if (index === -1) {
            this.mockResponses.push(data);
        } else {
            let updateData = false;
            if (confirmationReq) {
                const dialogRef = this.dialog.open(ReplaceMockDataConfirmationComponent, {
                    width: '40%',
                    height: 'auto',
                    data: {statusCode: data['statusCode']}
                });
                updateData = await dialogRef.afterClosed().toPromise();
            } else {
                updateData = true;
            }

            if (updateData) {
                this.mockResponses.splice(index, 1, data);
            }
        }
    }

    show(formData: string, formData2: any[]) {
        console.log(formData, ' = ', formData2);
    }

   
}
